<template>
    <div>
        <el-dialog class="el-dialog_wrapper" :visible.sync="dialogVisible" center @close="cancel" :close-on-click-modal="false">
            <div slot="title" class="dialog-head">
                <span class="head-title">Prompt Message</span>
            </div>
            <div class="dialog-body">
                <img class="img-c" src="../assets/pop-warning.png" alt='loading'></img>
                <span class="message-c">{{errorMessage}}</span>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button class="button-b" @click="cancel">close</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
    export default {
        name: 'Dialog',
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            }
        },

        methods: {
            cancel() {
                this.$emit("dialogClose", false);
            }
        }
    };
</script>

<style lang="less" scoped>
    @media screen and (max-width: 330px) {
        @import "../styles/mobile-i/m_dialog.less";
    }
    @media screen and (min-width: 331px)  and (max-width: 370px) {
        @import "../styles/mobile/m_dialog.less";
    }

    @media screen and (min-width: 371px) and (max-width: 400px) {
        @import "../styles/mobile_b/m_dialog.less";
    }

    @media screen and (min-width: 401px) and (max-width: 640px) {
        @import "../styles/mobile_p/m_dialog.less";
    }

    @media screen and (min-width: 641px) and (max-width: 800px) {
        @import "../styles/pad/dialog.less";
    }

    @media screen and (min-width: 801px) and (max-width: 1200px) {
        @import "../styles/pad_pro/dialog.less";
    }

    @media screen and (min-width: 1201px) {
        @import "../styles/pc/dialog.less";
    }
</style>


// WEBPACK FOOTER //
// src/views/Dialog.vue